/* PWA service worker registration helper.
 * Called once from src/index.js. No-ops in dev (http only on localhost OK).
 */
export const registerServiceWorker = () => {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Only register in production builds, but allow same-origin secure contexts.
  // Avoid registering when running inside an iframe (e.g. preview embeds).
  if (window.self !== window.top) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch(() => {
        /* registration errors are non-fatal */
      });
  });
};

/* Returns true when the app is running in standalone mode
 * (i.e. installed as a PWA on iOS/Android/Desktop). */
export const isStandalone = () => {
  if (typeof window === "undefined") return false;
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
};

export const isIos = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /iPad|iPhone|iPod/i.test(ua) && !window.MSStream;
};
